//此文件由工具自动生成,不要手动修改此文件
//在/centralsvn/BaseCode/wpcommonEditors/ModuleAuth.xlsm中修改并生成

let moduleAuthUtil = {};

moduleAuthUtil.getModuleAuthTable = function() {
	var dataTable = [
		{
			id : 1,
			name : "wpCore",
			authGroup : 1,
			define : "WP核心设置",
			auth : [
				{
					functionID : "configSetting", 
					chinese : "系统配置设定",
					english : "",
					chineseHelp : "系统配置设定",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 2,
			name : "wpOrganization",
			authGroup : 1,
			define : "WP组织架构",
			auth : [
				{
					functionID : "createOrganization", 
					chinese : "创建组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "1",
					check : false,
				},
				{
					functionID : "editOrganization", 
					chinese : "编辑组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteOrganization", 
					chinese : "删除组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "删除前需要2次确认",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "unApprovalOrganization", 
					chinese : "反审批组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "createDepartment", 
					chinese : "创建部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editDepartment", 
					chinese : "编辑部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deketeDepartment", 
					chinese : "删除部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 64,
					checkApply : "",
					check : false,
				},
				{
					functionID : "unApprovalDepartment", 
					chinese : "反审批部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 128,
					checkApply : "",
					check : false,
				},
				{
					functionID : "createJob", 
					chinese : "创建岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 256,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editJob", 
					chinese : "编辑岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 512,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteJob", 
					chinese : "删除岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1024,
					checkApply : "",
					check : false,
				},
				{
					functionID : "unApprovalJob", 
					chinese : "反审核岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2048,
					checkApply : "",
					check : false,
				},
				{
					functionID : "addEmployee", 
					chinese : "添加员工",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4096,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteEmployee", 
					chinese : "删除员工",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8192,
					checkApply : "",
					check : false,
				},
				{
					functionID : "changeJob", 
					chinese : "岗位调动",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16384,
					checkApply : "",
					check : false,
				},
				{
					functionID : "authorityAssignment", 
					chinese : "员工权限分配",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32768,
					checkApply : "",
					check : false,
				},
				{
					functionID : "changeOrganization", 
					chinese : "组织调动",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 65536,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 3,
			name : "wpAppManage",
			authGroup : 1,
			define : "WP管理APP",
			auth : [
				{
					functionID : "createAPP", 
					chinese : "创建APP",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "提交app创建信息也在此权限判断",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editCore", 
					chinese : "编辑核心内容",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "url(防止私下倒卖app账号), APP类型",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "delete", 
					chinese : "删除",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "freeze", 
					chinese : "冻结",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "unfreeze", 
					chinese : "解冻",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editBase", 
					chinese : "编辑基础内容",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "app名称 logo 图片 ICP",
					value : 32,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 4,
			name : "wpAppExtend",
			authGroup : 1,
			define : "WP管理APP扩展模块",
			auth : [
			],
		},
		{
			id : 5,
			name : "wpDataAnalysis",
			authGroup : 1,
			define : "WP数据",
			auth : [
			],
		},
		{
			id : 6,
			name : "wpService",
			authGroup : 1,
			define : "WP工单&客服",
			auth : [
				{
					functionID : "agentOperation", 
					chinese : "代客操作",
					english : "Agent operation",
					chineseHelp : "",
					englishHelp : "",
					comment : "替客人进行操作",
					value : 1,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 7,
			name : "wpMaintenance",
			authGroup : 1,
			define : "WP运维",
			auth : [
			],
		},
		{
			id : 8,
			name : "wpOrder",
			authGroup : 1,
			define : "WP订单",
			auth : [
			],
		},
		{
			id : 9,
			name : "wpWorkFlow",
			authGroup : 1,
			define : "WP工作流",
			auth : [
			],
		},
		{
			id : 10,
			name : "appCore",
			authGroup : 2,
			define : "App核心设置",
			auth : [
				{
					functionID : "getAccessInfo", 
					chinese : "查询认证信息",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "resetSecretKey", 
					chinese : "重置SecretKey",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getIpWhiteList", 
					chinese : "查看白名单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "changeIpWhiteList", 
					chinese : "修改白名单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "apiStaticData", 
					chinese : "OpenApi调用次数",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editApiAccount", 
					chinese : "编辑api调用账号",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getApiAccount", 
					chinese : "查看api调用账号",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 64,
					checkApply : "",
					check : false,
				},
				{
					functionID : "viewFieldTrans", 
					chinese : "查看字段转换",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 128,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editFieldTrans", 
					chinese : "编辑字段转换",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 256,
					checkApply : "",
					check : false,
				},
				{
					functionID : "delFieldTrans", 
					chinese : "删除字段转换",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 512,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getEventInterfaceWhiteList", 
					chinese : "获取事件接口白名单列表",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1024,
					checkApply : "",
					check : false,
				},
				{
					functionID : "addEventInterfaceWhiteList", 
					chinese : "添加事件接口白名单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2048,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editEventInterfaceWhiteList", 
					chinese : "编辑事件接口白名单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4096,
					checkApply : "",
					check : false,
				},
				{
					functionID : "delEventInterfaceWhiteList", 
					chinese : "删除事件接口白名单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8192,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 11,
			name : "appOrganization",
			authGroup : 2,
			define : "App组织架构",
			auth : [
				{
					functionID : "createOrganization", 
					chinese : "创建组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editOrganization", 
					chinese : "编辑组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteOrganization", 
					chinese : "删除组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "unApprovalOrganization", 
					chinese : "反审批组织",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "createDepartment", 
					chinese : "创建部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editDepartment", 
					chinese : "编辑部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteDepartment", 
					chinese : "删除部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 64,
					checkApply : "",
					check : false,
				},
				{
					functionID : "unApprovalDepartment", 
					chinese : "反审批部门",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 128,
					checkApply : "",
					check : false,
				},
				{
					functionID : "createJob", 
					chinese : "创建岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 256,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editJob", 
					chinese : "编辑岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 512,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteJob", 
					chinese : "删除岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1024,
					checkApply : "",
					check : false,
				},
				{
					functionID : "unApprovalJob", 
					chinese : "反审批岗位",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2048,
					checkApply : "",
					check : false,
				},
				{
					functionID : "addEmployee", 
					chinese : "添加员工",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4096,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editEmployee", 
					chinese : "编辑员工",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8192,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteEmployee", 
					chinese : "删除员工",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16384,
					checkApply : "",
					check : false,
				},
				{
					functionID : "changeJob", 
					chinese : "人事调动",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32768,
					checkApply : "",
					check : false,
				},
				{
					functionID : "authorityAssignment", 
					chinese : "员工权限分配",
					english : "Employee authority assignment",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 65536,
					checkApply : "",
					check : false,
				},
				{
					functionID : "registerForEmployee", 
					chinese : "代员工注册",
					english : "Register account for Employee",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 131072,
					checkApply : "",
					check : false,
				},
				{
					functionID : "addStaff", 
					chinese : "添加店员",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 262144,
					checkApply : "",
					check : false,
				},
				{
					functionID : "eitStaff", 
					chinese : "编辑店员",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 524288,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteStaff", 
					chinese : "删除员工",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1048576,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 12,
			name : "appDataAnalysis",
			authGroup : 2,
			define : "App数据分析",
			auth : [
			],
		},
		{
			id : 13,
			name : "appShopManage",
			authGroup : 2,
			define : "App下的店铺管理",
			auth : [
				{
					functionID : "createShop", 
					chinese : "添加门店",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editShop", 
					chinese : "编辑门店",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "delShop", 
					chinese : "删除门店",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "viewShop", 
					chinese : "预览门店",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 14,
			name : "appJourney",
			authGroup : 2,
			define : "App营销旅程设置",
			auth : [
				{
					functionID : "setSubscribeMessage", 
					chinese : "设置订阅消息",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "sendSubscribeMessage", 
					chinese : "发送订阅消息",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 15,
			name : "appPromotion",
			authGroup : 2,
			define : "App促销活动设置",
			auth : [
				{
					functionID : "editMgm", 
					chinese : "MGM活动编辑",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getMgm", 
					chinese : "MGM活动查看",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 16,
			name : "appAIService",
			authGroup : 2,
			define : "App智能客服设置",
			auth : [
			],
		},
		{
			id : 17,
			name : "appUser",
			authGroup : 2,
			define : "App用户数据",
			auth : [
			],
		},
		{
			id : 18,
			name : "appResource",
			authGroup : 2,
			define : "App素材库管理",
			auth : [
				{
					functionID : "view", 
					chinese : "查看资源库权限",
					english : "View store permissions",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "upload", 
					chinese : "上传资源权限",
					english : "Upload resource permission",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "rename", 
					chinese : "重命名资源权限",
					english : "Rename resource permission",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "delete", 
					chinese : "删除资源权限(移入回收站)",
					english : "Delete resource permission (move to recycle)",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "moveTo", 
					chinese : "移动资源权限",
					english : "Move resource permission",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
				{
					functionID : "permanentlyDelete", 
					chinese : "永久删除资源权限",
					english : "Permanently delete resource permissions",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32,
					checkApply : "",
					check : false,
				},
				{
					functionID : "addDirectory", 
					chinese : "新建文件夹权限",
					english : "New folder permissions",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 64,
					checkApply : "",
					check : false,
				},
				{
					functionID : "delDirectory", 
					chinese : "删除文件夹权限(移入回收站)",
					english : "Delete folder permission (move to recycle)",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 128,
					checkApply : "",
					check : false,
				},
				{
					functionID : "renameDirectory", 
					chinese : "重命名文件夹权限",
					english : "Rename folder permission",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 256,
					checkApply : "",
					check : false,
				},
				{
					functionID : "permanentlyDeleteDirectory", 
					chinese : "永久删除文件夹权限",
					english : "Permanently delete folder permissions",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 512,
					checkApply : "",
					check : false,
				},
				{
					functionID : "recovery", 
					chinese : "恢复资源",
					english : "Recovery resource permission",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1024,
					checkApply : "",
					check : false,
				},
				{
					functionID : "recoveryDirectory", 
					chinese : "恢复文件夹",
					english : "Recovery directory permission",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2048,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 19,
			name : "appClassify",
			authGroup : 2,
			define : "App分类编辑管理",
			auth : [
			],
		},
		{
			id : 20,
			name : "appCommodity",
			authGroup : 2,
			define : "App商品编辑管理",
			auth : [
				{
					functionID : "addCommdoity", 
					chinese : "添加商品",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteCommdoity", 
					chinese : "删除商品",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "updateCommdoity", 
					chinese : "编辑商品",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getCommodityInfo", 
					chinese : "获取商品信息",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getCommodityList", 
					chinese : "获取商品列表",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 21,
			name : "appShelves",
			authGroup : 2,
			define : "App货架编辑管理",
			auth : [
			],
		},
		{
			id : 22,
			name : "appPage",
			authGroup : 2,
			define : "App页面编辑",
			auth : [
			],
		},
		{
			id : 23,
			name : "appStock",
			authGroup : 2,
			define : "App库存管理",
			auth : [
				{
					functionID : "addShopInventory", 
					chinese : "添加门店库存记录",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editShopInventory", 
					chinese : "修改门店库存",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteShopInventory", 
					chinese : "删除门店库存",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "increaseShopInventory", 
					chinese : "增加门店库存量",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 24,
			name : "appOrder",
			authGroup : 2,
			define : "App订单管理",
			auth : [
				{
					functionID : "importOrder", 
					chinese : "订单导入",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "updateOrder", 
					chinese : "修改订单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "delOrder", 
					chinese : "删除订单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "viewOrder", 
					chinese : "查看订单",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 25,
			name : "appWorkFlow",
			authGroup : 2,
			define : "App工作流管理",
			auth : [
			],
		},
		{
			id : 26,
			name : "shopCore",
			authGroup : 3,
			define : "Shop核心设置",
			auth : [
			],
		},
		{
			id : 27,
			name : "shopOrganization",
			authGroup : 3,
			define : "Shop组织架构",
			auth : [
			],
		},
		{
			id : 28,
			name : "shopDataAnalysis",
			authGroup : 3,
			define : "Shop数据分析",
			auth : [
			],
		},
		{
			id : 29,
			name : "shopUser",
			authGroup : 3,
			define : "Shop用户数据",
			auth : [
			],
		},
		{
			id : 30,
			name : "shopWaiter",
			authGroup : 3,
			define : "Shop服务员管理",
			auth : [
			],
		},
		{
			id : 31,
			name : "shopService",
			authGroup : 3,
			define : "Shop客服",
			auth : [
			],
		},
		{
			id : 32,
			name : "shopPromotion",
			authGroup : 3,
			define : "Shop促销活动设置",
			auth : [
			],
		},
		{
			id : 33,
			name : "shopStock",
			authGroup : 3,
			define : "Shop库存管理",
			auth : [
			],
		},
		{
			id : 34,
			name : "shopOrder",
			authGroup : 3,
			define : "Shop订单管理",
			auth : [
			],
		},
		{
			id : 35,
			name : "shopWorkFlow",
			authGroup : 3,
			define : "Shop工作流管理",
			auth : [
			],
		},
		{
			id : 36,
			name : "appPoint",
			authGroup : 2,
			define : "App积分管理",
			auth : [
				{
					functionID : "editPointGroup", 
					chinese : "编辑积分组",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getPointGroup", 
					chinese : "查看积分组",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editPointGain", 
					chinese : "编辑积分获取",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getPointGain", 
					chinese : "查看积分获取",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getPointList", 
					chinese : "用户积分查询",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
				{
					functionID : "exportPointList", 
					chinese : "用户积分导出",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32,
					checkApply : "",
					check : false,
				},
				{
					functionID : "changUserPoint", 
					chinese : "修改用户积分",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 64,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 37,
			name : "appInterestedTag",
			authGroup : 2,
			define : "App兴趣标签管理",
			auth : [
				{
					functionID : "editInterestedTagGroup", 
					chinese : "编辑兴趣标签组",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getInterestedTagGroup", 
					chinese : "查看兴趣标签组",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editInterestedTag", 
					chinese : "编辑兴趣标签",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "getInterestedTag", 
					chinese : "查看兴趣标签",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
			],
		},
		{
			id : 38,
			name : "appCoupon",
			authGroup : 2,
			define : "App优惠券管理",
			auth : [
				{
					functionID : "addCoupon", 
					chinese : "添加优惠券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteCoupon", 
					chinese : "删除优惠券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editCoupon", 
					chinese : "编辑优惠券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 4,
					checkApply : "",
					check : false,
				},
				{
					functionID : "couponInfo", 
					chinese : "优惠券详情",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 8,
					checkApply : "",
					check : false,
				},
				{
					functionID : "couponList", 
					chinese : "优惠券列表",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 16,
					checkApply : "",
					check : false,
				},
				{
					functionID : "sendCouponManually", 
					chinese : "手动发券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 32,
					checkApply : "",
					check : false,
				},
				{
					functionID : "sendCouponByCSV", 
					chinese : "使用CSV批量派券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 64,
					checkApply : "",
					check : false,
				},
				{
					functionID : "downloadCSVTemplateForSendCoupon", 
					chinese : "下载CSV派券模板",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 128,
					checkApply : "",
					check : false,
				},
				{
					functionID : "exportSendReport", 
					chinese : "导出发券报告",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 256,
					checkApply : "",
					check : false,
				},
				{
					functionID : "addCouponDirectional", 
					chinese : "添加定向发券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 512,
					checkApply : "",
					check : false,
				},
				{
					functionID : "deleteCouponDirectional", 
					chinese : "删除定向发券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 1024,
					checkApply : "",
					check : false,
				},
				{
					functionID : "editCouponDirectional", 
					chinese : "编辑定向发券",
					english : "",
					chineseHelp : "",
					englishHelp : "",
					comment : "",
					value : 2048,
					checkApply : "",
					check : false,
				},
			],
		},
	];
	return dataTable;
};

export default moduleAuthUtil;



// WEBPACK FOOTER //
// ./src/utils/ModuleAuthUtil.js